






























import { CheckIsMUZE } from "@/helper/shareHelper";
import { Component, Vue } from "vue-property-decorator";

const isMUZE = CheckIsMUZE();

@Component
export default class RedirectToLoginOrOldPeak extends Vue {
  private widthScreen = 0;
  private isMUZE = isMUZE;

  mounted() {
    this.widthScreen = window.innerWidth;
    window.addEventListener("resize", () => {
      this.widthScreen = window.innerWidth;
    });
  }

  public RedirectToLogin() {
    location.replace(process.env.VUE_APP_PeakAccount);
  }
}
